var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPremiumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "3 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37282 19.6641C6.74782 19.9453 7.20876 19.8594 7.74001 19.4688L11.8025 16.4844L15.8572 19.4688C16.3884 19.8594 16.8494 19.9453 17.2244 19.6641C17.5916 19.3906 17.6697 18.9297 17.4588 18.3125L15.8572 13.5391L19.9509 10.6016C20.4822 10.2266 20.7009 9.80469 20.5525 9.36719C20.4041 8.92969 19.99 8.71094 19.3338 8.72656L14.3181 8.75781L12.7869 3.96094C12.5838 3.33594 12.2634 3 11.8025 3C11.3338 3 11.0134 3.33594 10.8103 3.96094L9.28688 8.75781L4.26344 8.72656C3.60719 8.71094 3.19313 8.92969 3.04469 9.36719C2.89626 9.80469 3.12282 10.2266 3.64626 10.6016L7.74001 13.5391L6.13844 18.3125C5.92751 18.9297 6.00563 19.3906 6.37282 19.6641Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumIcon);
export default __webpack_public_path__ + "static/media/premium-icon.e36969c2d2dfa12e282ee04ce40bffaa.svg";
export { ForwardRef as ReactComponent };